// The weight unit chosen in Profile (#191), "kg" or "lb", for fields and
// readouts that show weights. Its own tiny module so components don't pull
// WorkoutContext's import tree in. Provided by WorkoutProvider; "kg" outside.
import { createContext, useContext } from "react";

export const WeightUnitContext = createContext("kg");

export const useWeightUnit = () => useContext(WeightUnitContext);
